import { resetRouter, asyncRoutes } from '../../router'
import backend from '../../conf/backend';
import { apiObj } from '../../conf/api/index';

const state = {
    token: common_tool.getDataFromLocal('token') || '', // 调用第三方组件的 token
    isAddRoutes: false,
    userInfo: {},
    usertype: null,
    areaList: [],
}
const getters = {}

const mutations = {
    setUserInfo(state, userInfo) {
        state.userInfo = {...state.userInfo, ...userInfo }
        common_tool.saveDataToLocal('userInfo', userInfo)
    },
    removeUserInfo(state) {
        state.userInfo = {}
        common_tool.clearLocalData('userInfo')
    },
    // 登录token
    setSignToken(state, signToken) {
        state.signToken = signToken
        common_tool.saveDataToCookie('signToken', signToken)
    },
    removeSignToken() {
        common_tool.clearDataCookie('signToken')
    },
    // 登录人类型
    setUsertype(state, usertype) {
        state.usertype = usertype
        common_tool.saveDataToLocal('usertype', usertype)
    },
    removeUsertype(state) {
        state.usertype = null
        common_tool.clearLocalData('usertype')
    },
    // 更新 token
    setToken(state, token) {
        state.token = token
        common_tool.saveDataToLocal('token', token)
    },
    // 删除 token
    removeToken(state) {
        state.token = null
        common_tool.clearLocalData('token')
    },
    // 一个用户只能使用一次，所以要加一个状态值
    setIsAddRoutes(state, value) {
        state.isAddRoutes = value
    },
    setAreaList(state, value) {
        state.areaList = value
    }
}

const actions = {
    async login({ commit }, result) {
        commit('setSignToken', result.token)
        commit('setUsertype', result.usertype)
        let userInfo = await backend.request(apiObj.hotel.getPersonInfo, result)
        if (userInfo) commit('setUserInfo', userInfo)
    },

    logout({ commit }) {
        // 删除 token
        commit('removeSignToken')
            // 删除 userInfo
        commit('removeUserInfo')
        commit('removeUsertype')
            // 重置路由锁
        commit('setIsAddRoutes', false)
            // 臨時注销
            // commit('removeToken', false)
            // 重置路由
        resetRouter()
            // 清空 VUEX 中的数据
    },
    removeToken({ commit }) {
        commit('removeToken', null)
    },
    async getToken({ commit }) {
        const params = {
            client_id: 'ca5c9755-86a0-4dc3-80af-4b0a5f9e35e2',
            grant_type: 'client_credentials',
            client_secret: 'f58101ed-b2f9-4127-871e-90603e4a9564'
        }
        const { status, custom } = await backend.request(apiObj.common.getThirdToken, params)
        if (status && status.code == 1) {
            await commit('setToken', custom.access_token)
        }
    },
    // 处理辖区
    async handlerArea({ state, commit }, areacode) {
        let areaList = await backend.request(apiObj.hotel.getAreaCode)
        if (areaList.length > 0) {
            areaList = areaList[0].children
            commit('setAreaList', areaList)
        }
        if (!areacode) return
            // 市级机构
        const parentOrgCode = areacode.slice(0, 4) + '00000000'
        let { userInfo } = state
        let children = []
        let areaName = ''
        let papers = ['江苏省']
        areaList.forEach(item => {
            if (item.orgCode === parentOrgCode) {
                papers.push(item.orgName)
                children = item.children
                item.children.forEach(it => {
                    if (it.orgCode === areacode) {
                        areaName = it.orgName
                    }
                })
            }
        })
        userInfo = { parentOrgCode, children, areacode, areaName, papers }
        commit('setUserInfo', userInfo)
    },
    // 处理动态路由
    handlerAsyncRoutes({ state }) {
        let newRoutes = []
        asyncRoutes.forEach(item => {
            const router = handlerAsyncRoutes(item, state.roleMenuList)
            if (router && JSON.stringify(router) !== '{}') {
                newRoutes.push(router)
            }
        })
        return newRoutes
    }
}

// 处理权限路由路径
function handlerAsyncRoutes(conf, roleMenuList) {
    const { meta: { roleName } } = conf
    let route = undefined
    if (roleName && roleMenuList.includes(roleName)) {
        route = {...conf }
    } else {
        return route
    }
    if (conf.children && conf.children instanceof Array) {
        route.children = []
        for (let child of conf.children) {
            let childRoute = handlerAsyncRoutes(child, roleMenuList)
            if (typeof childRoute !== 'undefined') {
                route.children.push(childRoute)
            }
        }
    }
    return route
}

export default {
    state,
    getters,
    mutations,
    actions
};


// WEBPACK FOOTER //
// ./src/store/modules/user.js